import * as React from "react";
import { css } from "@emotion/react";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";

interface IProps {
  children: React.ReactNode;
  isShow: boolean;
  styleKey?: keyof IStyle;
  widthStyle?: string;
  maxWidthStyle?: string;
  fontSizeStyle?: string;
}

const ButtonComponent: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const {
    children,
    isShow,
    styleKey = "default",
    widthStyle = "100%",
    maxWidthStyle = "14rem",
    fontSizeStyle,
    ...rest
  } = props;
  const styles = isShow
    ? [buttonStyle[styleKey], buttonShowStyle[styleKey]]
    : buttonStyle[styleKey];

  const customizeStyles = css`
    width: ${widthStyle};
    max-width: ${maxWidthStyle};
    ${fontSizeStyle ? `font-size: ${fontSizeStyle};` : ""}
  `;
  return (
    <div css={[styles, customizeStyles]} {...rest}>
      {children}
    </div>
  );
};
export const ShowMoreButton: any = React.memo(ButtonComponent);

export interface IStyle {
  default: any;
  minimal: any;
}

const buttonStyle: IStyle = {
  default: css`
    position: relative;
    cursor: pointer;
    color: ${accentColor.primaryColor};
    font-size: ${fontSize.caption};
    font-weight: ${fontWeight.medium};
    border-bottom: 0.125rem solid;
    padding: ${space.atom} 2rem ${space.atom} 1.5rem;
    width: 100%;
    max-width: 14rem;
    text-align: center;
    transition: color 0.4s ease;
    box-sizing: border-box;
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 0.5rem;
      height: 0.5rem;
      border: 0.125rem solid;
      border-top: 0;
      border-left: 0;
      top: 50%;
      right: 0.5rem;
      transition: transform 0.4s ease;
      transform: translateY(-75%) rotate(45deg);
    }
    &:hover {
      color: ${textColor.primaryDarkColor};
    }
  `,
  minimal: css`
    position: relative;
    cursor: pointer;
    display: inline-block;
    color: ${accentColor.primaryColor};
    font-size: ${fontSize.caption};
    font-weight: ${fontWeight.medium};
    padding: ${space.atom} 2rem ${space.atom} 0;
    max-width: 14rem;
    text-align: center;
    transition: color 0.4s ease;
    box-sizing: border-box;
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 0.5rem;
      height: 0.5rem;
      border: 0.125rem solid;
      border-top: 0;
      border-left: 0;
      top: 50%;
      right: 0.5rem;
      transition: transform 0.4s ease;
      transform: translateY(-75%) rotate(45deg);
    }
    &:hover {
      color: ${accentColor.primaryDarkColor};
    }
  `,
};

const buttonShowStyle: IStyle = {
  default: css`
    &::after {
      transform: translateY(-25%) rotate(225deg);
    }
  `,
  minimal: css`
    &::after {
      transform: translateY(-25%) rotate(225deg);
    }
  `,
};
